import { CodeSubject } from './code-subject-section';

export const keyAllChildren = [
  CodeSubject.FIGLIO_1,
  CodeSubject.FIGLIO_2,
  CodeSubject.FIGLIO_3,
  CodeSubject.FIGLIO_4,
  CodeSubject.FIGLIO_5,
  CodeSubject.FIGLIO_6,
  CodeSubject.FIGLIO_7,
  CodeSubject.FIGLIO_8,
  CodeSubject.FIGLIO_9,
  CodeSubject.FIGLIO_10,
  CodeSubject.FIGLIO_11,
  CodeSubject.FIGLIO_12,
  CodeSubject.FIGLIO_13,
  CodeSubject.FIGLIO_14,
  CodeSubject.FIGLIO_15,
  CodeSubject.FIGLIO_16,
  CodeSubject.FIGLIO_17,
  CodeSubject.FIGLIO_18,
  CodeSubject.FIGLIO_19,
  CodeSubject.FIGLIO_20,
];
